import React from 'react'
import { useTranslation } from 'hooks/useTranslation'
import Head from 'next/head'
import { CreatePassword } from 'features/Login/components/CreatePassword'

export default function CreatePasswordPage() {
  const { t } = useTranslation()
  return (
    <div>
      <Head>
        <title>{t('create-password:title')}</title>
      </Head>

      <main>
        <CreatePassword />
      </main>
    </div>
  )
}
